module.exports = __webpack_public_path__ + "static/media/icon_keyboard-down.6f748928.svg";